import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styles } from "@repo/helpers";
import { MouseEvent, useMemo } from "react";

import style from "./style.module.scss";
import { MarkupProps } from "./types";

export function ModalMarkup(props: MarkupProps) {
	const {
		header,
		body,
		footer,
		headerClass,
		bodyClass,
		footerClass,
		showClose,
		movable,
		modalContentRef,
		modalRef,
		removeBodyStyling,
		defaultWidth,
		defaultHeight,
		resize,
	} = props;
	const headerMarkup = useMemo(renderHeader, [header, movable, showClose, props.closeModal]);
	const bodyMarkup = useMemo(renderBody, [body, removeBodyStyling, bodyClass]);
	const footerMarkup = useMemo(renderFooter, [footer]);

	const modalClass = styles(style.modal, props.visible ? style.visible : null);

	// Create inline styles for default dimensions and resizing
	const modalContentStyle: React.CSSProperties = {
		...(defaultWidth && { width: `${defaultWidth}px` }),
		...(defaultHeight && { height: `${defaultHeight}px` }),
		...(resize && { resize: "both", overflow: "auto" }),
	};

	return (
		<div
			className={modalClass}
			onClick={(event: MouseEvent<HTMLDivElement>) => props.handleOffClick(event, false)}
			ref={modalRef}
		>
			<div
				className={styles(style.modalContent, props.className)}
				style={modalContentStyle}
				onClick={(event: MouseEvent<HTMLDivElement>) => props.handleOffClick(event, true)}
				ref={modalContentRef}
			>
				{headerMarkup}
				{bodyMarkup}
				{footerMarkup}
			</div>
		</div>
	);

	function renderHeader() {
		if (!header && !showClose) return null;
		return (
			<div
				className={styles(headerClass, style.modalHeader)}
				onMouseDown={movable ? props.moveMouseDown : undefined}
			>
				{header}
				{showClose ? (
					<span className={style.close} onClick={props.closeModal}>
						<FontAwesomeIcon icon={faTimes} className={style.close} />
					</span>
				) : null}
			</div>
		);
	}

	function renderBody() {
		if (!body) return null;
		const modalBodyClass = removeBodyStyling ? style.modalBodyNoStyling : style.modalBody;
		return <div className={styles(bodyClass, modalBodyClass)}>{body}</div>;
	}

	function renderFooter() {
		if (!footer) return null;
		return <div className={styles(footerClass)}>{footer}</div>;
	}
}
